export default __webpack_public_path__ + "static/media/bigappslogo.46d4a4e6.png";